<template>
  <div class="bexs-autosuggest">
    <input
      id="UserProductServices"
      ref="UserProductServices"
      autocomplete="off"
      :class="{ 'has-error': hasError }"
      type="text"
      class="form-control"
      :placeholder="$t('login.fields.typeToSearch')"
    />

    <button
      v-show="productSelected"
      type="button"
      class="close"
      @click="fieldUpdated('')"
    >
      <i class="icon-close"></i>
      <span class="sr-only">Close</span>
    </button>

    <typeahead
      :value="productSelected"
      :open-on-empty="true"
      :async-function="fetch"
      target="#UserProductServices"
      item-key="name"
    >
      <template slot="item" slot-scope="props">
        <li
          v-for="(item, index) in props.items"
          :key="item.id"
          :class="{ active: props.activeIndex === index }"
        >
          <div
            class="autocomplete-template"
            :title="`${item.name}`"
            @click.prevent="fieldUpdated(item)"
          >
            <div class="bexs-thumb" size="xsmall">
              <img
                v-if="
                  item.thumbUrlEncrypted != '' && item.thumbUrlEncrypted != null
                "
                :src="getThumb(item.thumbUrlEncrypted)"
                class="img-circle"
              />

              <img
                v-else
                :src="getThumb()"
                class="img-circle"
                alt=""
                title=""
              />
            </div>

            <div class="text with-thumb">
              <dl class="text-left">
                <dt>{{ item.productCategory }}</dt>

                <dd>{{ item.name }}</dd>
              </dl>
            </div>
          </div>
        </li>
      </template>
    </typeahead>
  </div>
</template>

<script>
  import services from '@/services'

  import Issue from './emission-field'

  export default {
    name: 'UserProductServiceField',
    props: {
      id: {
        type: String,
        required: true
      },
      value: {
        default: '',
        required: false
      },
      hasError: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        fieldValue: undefined,
        baseURL: process.env.BASE_URL,
        mainURL: undefined
      }
    },
    computed: {
      productSelected() {
        return (
          this.fieldValue ||
          (this.value.fieldId ? this.value.fieldValue : this.value)
        )
      }
    },
    created() {
      services.main.getMainUrl().then(mainURL => (this.mainURL = mainURL))
    },
    methods: {
      fetch(query, done) {
        services.persons.searchUserProducts(query).then(s => {
          done(s)
        })
      },
      fieldUpdated(item) {
        this.fieldValue = item

        this.$emit('input', Issue.createField(this.id, this.fieldValue, false))
      },
      getThumb(thumbUrl) {
        return thumbUrl
          ? `${this.mainURL}/image/get?urlImage=${thumbUrl}`
          : `${this.baseURL}/images/thumb-produto.jpg`
      }
    }
  }
</script>

<style scoped>
  .has-error {
    border: 1px solid #d7443d !important;
    border-radius: 8px;
  }
</style>
